<template>
    <div>
        <DevicePanel
            :show.sync="parentDevicePanelMixin.showDevicePanel"
            :device="parentDevicePanelMixin.settingsDevice"
            @openSettings="parentDevicePanelMixin.openSettingsDevicePanel($event)"
        >
        </DevicePanel>
        <SettingsDevicePanel
            :show.sync="parentDevicePanelMixin.showSettingsDevicePanel"
            :device="parentDevicePanelMixin.settingsDevice"
            :location="parentDevicePanelMixin.settingsLocation"
            @updateDevice="$emit('updateDevice')"
            @deleteDevice="deleteDevice()"
        ></SettingsDevicePanel>
    </div>
</template>

<script>
    import DevicePanel from '../view_panels/DevicePanel';
    import SettingsDevicePanel from '../view_panels/SettingsDevicePanel';

    export default {
        name: 'DevicePanelMixinPanel',
        inject: ['parentDevicePanelMixin'],
        components: { DevicePanel, SettingsDevicePanel },
        methods: {
            deleteDevice() {
                this.parentDevicePanelMixin.showDevicePanel = false;
                this.$nextTick(() => {
                    this.$emit('updateDevice');
                    this.$emitInstance('refresh');
                });
            },
        },
    };
</script>
